module.exports = __webpack_public_path__ + "img/ciz.svg";